const locale = require('./wizard.i18n.json');
/*@ngInject*/
const WizardController = function ($rootScope, $scope, $stateParams, $state, $timeout, appTypeConfigurationModel, currentSubmissionModel, submissionMediator, checklistMediator, submissionStateMediator, submissionConstant, coreConstant, quoteMediator, formViewerConstant, wizardMediator, wizardActionUtil, wizardActionHandlerUtil) {


    $scope.viewModel = {
        submission: null,
        submissionId: $stateParams.submissionId,
        proposalId: null,
        quoteId: null,
        reportId: null,
        policyIssuanceId: null,
        policyId: null,
        policyCancellationId: null,
        policyRewriteId: null,
        endorsementId: null,
        wizardProgressLabel: '',
        isUnderwriterWorkstation: appTypeConfigurationModel.isUnderwriterWorkstation(),
        uncheckedChecklistItemCount: 0,
        checklistItemCount: 0,
        openDrawers: {
            collaboration: false,
            activityStream: false,
            checklist: false,
            snippets: false
        },
        totalSnippetsItems: [],
        i18n: locale
    };

    $scope.actions = [];
    $scope.context = {
        identifier: 'submission',
        actions: {},
        fallthrough: submissionConstant.CONTEXT_SUBMISSION,
        model: {}
    };
    // Note that order of the context matters due to a "startsWith" check to select a context
    // This mean that contexts which contain a word that is used for the context selection needs to first (e.g. PolicyIssuance, PolicyCancellation, etc... before Policy)
    $scope.context.actions[submissionConstant.CONTEXT_QUOTE] = 'Quote';
    $scope.context.actions[submissionConstant.CONTEXT_REPORT] = 'Report';
    $scope.context.actions[submissionConstant.CONTEXT_PROPOSAL] = 'Proposal';
    $scope.context.actions[submissionConstant.CONTEXT_POLICY_ISSUANCE] = 'PolicyIssuance';
    $scope.context.actions[submissionConstant.CONTEXT_POLICY_CANCELLATION] = 'PolicyCancellation';
    $scope.context.actions[submissionConstant.CONTEXT_POLICY_REWRITE] = 'PolicyRewrite';
    $scope.context.actions[submissionConstant.CONTEXT_POLICY_REISSUE] = 'PolicyReissue';
    $scope.context.actions[submissionConstant.CONTEXT_POLICY] = 'Policy';
    $scope.context.actions[submissionConstant.CONTEXT_ENDORSEMENT] = 'Endorsement';

    function loadActions() {
        var actionIds = wizardActionUtil.getActionIds($scope.context.model.hierarchicalContextList);

        function loadActionsInternal() {
            wizardActionUtil.resetActions();

            wizardActionUtil.getAllActions(actionIds).then(function (allActions) {
                $scope.actions = allActions;
                $scope.actionsTimeLastModified = new Date().getTime();
            });
        }

        if (!_.isNil(currentSubmissionModel.getCurrentNewSubmission())) {
            loadActionsInternal();
        } else {
            submissionMediator.clearCurrentActionRegistrations().finally(function () {
                loadActionsInternal();
            });
        }
    }

    $scope.isOneDrawerOpen = function () {
        var isCollabOpen = ($scope.viewModel.openDrawers.collaboration === true),
            isActivityOpen = ($scope.viewModel.openDrawers.activityStream === true),
            isChecklistOpen = ($scope.viewModel.openDrawers.checklist === true),
            isSnippetsOpen = ($scope.viewModel.openDrawers.snippets === true);
        return isCollabOpen || isActivityOpen || isChecklistOpen || isSnippetsOpen;
    };

    $scope.onToggleChecklist = function () {
        $rootScope.$broadcast(submissionConstant.event.CLOSE_COLLABORATION);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_ACTIVITY_STREAM);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_SNIPPETS);
        $rootScope.$broadcast(submissionConstant.event.TOGGLE_CHECKLIST);
    };

    $scope.onToggleCollaboration = function () {
        $rootScope.$broadcast(submissionConstant.event.CLOSE_CHECKLIST);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_ACTIVITY_STREAM);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_SNIPPETS);
        $rootScope.$broadcast(submissionConstant.event.TOGGLE_COLLABORATION);
    };

    $scope.onToggleSnippets = function () {
        $rootScope.$broadcast(submissionConstant.event.CLOSE_CHECKLIST);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_COLLABORATION);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_ACTIVITY_STREAM);
        $rootScope.$broadcast(submissionConstant.event.TOGGLE_SNIPPETS);
    };

    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
        if (parseInt($stateParams.submissionId) === submission.id) {
            refreshSubmission(submission);
        }
    });

    $scope.$on(submissionConstant.event.ACTIVITY_STREAM_DID_OPEN, function () {
        resetOpenDrawers();
        $scope.viewModel.openDrawers.activityStream = true;
    });
    $scope.$on(submissionConstant.event.COLLABORATION_DID_OPEN, function () {
        resetOpenDrawers();
        $scope.viewModel.openDrawers.collaboration = true;
    });
    $scope.$on(submissionConstant.event.CHECKLIST_DID_OPEN, function () {
        resetOpenDrawers();
        $scope.viewModel.openDrawers.checklist = true;
    });
    $scope.$on(submissionConstant.event.SNIPPETS_DID_OPEN, function () {
        resetOpenDrawers();
        $scope.viewModel.openDrawers.snippets = true;
    });

    $scope.$on(submissionConstant.event.ACTIVITY_STREAM_DID_CLOSE, resetOpenDrawers);
    $scope.$on(submissionConstant.event.COLLABORATION_DID_CLOSE, resetOpenDrawers);
    $scope.$on(submissionConstant.event.CHECKLIST_DID_CLOSE, resetOpenDrawers);
    $scope.$on(submissionConstant.event.SNIPPETS_DID_CLOSE, resetOpenDrawers);

    function resetOpenDrawers() {
        $scope.viewModel.openDrawers.activityStream = false;
        $scope.viewModel.openDrawers.collaboration = false;
        $scope.viewModel.openDrawers.checklist = false;
        $scope.viewModel.openDrawers.snippets = false;
    }

    function loadDrawersState() {
        $scope.viewModel.openDrawers.activityStream = _.get(submissionStateMediator.getActivityStreamState($stateParams.submissionId), 'isOpen');
        $scope.viewModel.openDrawers.checklist = _.get(submissionStateMediator.getChecklistState($stateParams.submissionId), 'isOpen');
        $scope.viewModel.openDrawers.collaboration = _.get(submissionStateMediator.getCollaborationState($stateParams.submissionId), 'isOpen');
        $scope.viewModel.openDrawers.snippets = _.get(submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId), 'isOpen');
    }

    function refreshSubmission(submission) {
        $scope.viewModel.submission = submission;
        refreshChecklistItemCount();
    }

    function refreshChecklistItemCount() {
        checklistMediator.getChecklistItems($stateParams.submissionId).then(function (checkListHierarchy) {
            $scope.viewModel.checklistItemCount = checkListHierarchy.totalCount;
            $scope.viewModel.uncheckedChecklistItemCount = checkListHierarchy.totalUncheckedCount;
        });
    }

    $scope.$on(submissionConstant.event.REFRESH_CHECKLIST_ITEM_COUNT, function () {
        refreshChecklistItemCount();
    });

    $scope.handleAction = function (action, file) {
        wizardActionHandlerUtil.handleAction(action, file, $scope.viewModel.quoteId, $scope.viewModel.reportId, $scope.viewModel.proposalId, $scope.viewModel.policyId, $scope.viewModel.policyIssuanceId, $scope.viewModel.endorsementId, $scope.viewModel.policyCancellationId, $scope.viewModel.policyRewriteId);
    };

    $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function (event, updateActionsMessage, entityType, entityId) {
        var contextActions,
            contextType;

        if (entityType === 'submission' && parseInt($scope.viewModel.submissionId) === entityId) {
            contextType = submissionConstant.CONTEXT_SUBMISSION;
        } else if (entityType === 'quote' && parseInt($scope.viewModel.quoteId) === entityId) {
            contextType = submissionConstant.CONTEXT_QUOTE;
        } else if (entityType === 'policyissuance' && parseInt($scope.viewModel.policyIssuanceId) === entityId) {
            contextType = submissionConstant.CONTEXT_POLICY_ISSUANCE;
        } else if (entityType === 'proposal' && parseInt($scope.viewModel.proposalId) === entityId) {
            contextType = submissionConstant.CONTEXT_PROPOSAL;
        } else if (entityType === 'policy' && parseInt($scope.viewModel.policyId) === entityId) {
            contextType = submissionConstant.CONTEXT_POLICY;
        } else if (entityType === 'policycancellation' && parseInt($scope.viewModel.policyCancellationId) === entityId) {
            contextType = submissionConstant.CONTEXT_POLICY_CANCELLATION;
        } else if (entityType === 'externalreport' && parseInt($scope.viewModel.reportId) === entityId) {
            contextType = submissionConstant.CONTEXT_REPORT;
        } else if (entityType === 'endorsement' && parseInt($scope.viewModel.endorsementId) === entityId) {
            contextType = submissionConstant.CONTEXT_ENDORSEMENT;
        } else if (entityType === 'policyrewrite' && parseInt($scope.viewModel.policyRewriteId) === entityId) {
            contextType = submissionConstant.CONTEXT_POLICY_REWRITE;
        } else if (entityType === 'policyreissue' && parseInt($scope.viewModel.policyReissueId) === entityId) {
            contextType = submissionConstant.CONTEXT_POLICY_REISSUE;
        }

        contextActions = _.find($scope.actions, {'contextType': contextType});
        if (contextActions) {
            contextActions.actions = updateActionsMessage.actions.actions;
        }

        $scope.actionsTimeLastModified = new Date().getTime();
    });

    $scope.$on(submissionConstant.event.CONTEXT_CHANGED, function (e, updatedContext) {
        var oldContext = $scope.context.model,
            updatedContextIsEmpty = _.isEmpty(updatedContext.hierarchicalContextList),
            oldContextIsEmpty = _.isEmpty(oldContext.hierarchicalContextList);

        $scope.context.model = updatedContext;

        $scope.viewModel.quoteId = null;
        $scope.viewModel.reportId = null;
        $scope.viewModel.policyIssuanceId = null;
        $scope.viewModel.proposalId = null;
        $scope.viewModel.policyId = null;
        $scope.viewModel.policyCancellationId = null;
        $scope.viewModel.endorsementId = null;
        $scope.viewModel.policyRewriteId = null;
        $scope.viewModel.policyReissueId = null;

        $scope.viewModel.wizardProgressLabel = updatedContext.contextLabel;

        _.each(updatedContext.hierarchicalContextList, function (hierarchicalContext) {
            if (hierarchicalContext.contextType === submissionConstant.CONTEXT_SUBMISSION) {
                $scope.viewModel.submissionId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_QUOTE) {
                $scope.viewModel.quoteId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_REPORT) {
                $scope.viewModel.reportId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_ISSUANCE) {
                $scope.viewModel.policyIssuanceId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_PROPOSAL) {
                $scope.viewModel.proposalId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY) {
                $scope.viewModel.policyId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_CANCELLATION) {
                $scope.viewModel.policyCancellationId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_ENDORSEMENT) {
                $scope.viewModel.endorsementId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_REWRITE) {
                $scope.viewModel.policyRewriteId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_REISSUE) {
                $scope.viewModel.policyReissueId = hierarchicalContext.contextId;
            }
        });

        refreshChecklistItemCount();

        if (updatedContextIsEmpty || oldContextIsEmpty) {
            loadActions();
        } else {
            // Find the changes
            handleContextChanges(updatedContext, oldContext);
        }
    });

    function handleContextChanges(newContext, oldContext) {
        var contextsToAdd = _.filter(newContext.hierarchicalContextList, function (contextA) {
                var contextInOldList = _.find(oldContext.hierarchicalContextList, function (contextB) {
                    return contextA.contextType === contextB.contextType && contextA.contextId === contextB.contextId;
                });
                return !contextInOldList;
            }),
            contextsToRemove = _.filter(oldContext.hierarchicalContextList, function (contextA) {
                var contextInNewList = _.find(newContext.hierarchicalContextList, function (contextB) {
                    return contextB.contextType === contextA.contextType && contextB.contextId === contextA.contextId;
                });
                return !contextInNewList;
            }),
            registrationsToRemove = [],
            registration,
            actionIdsToAdd = {};

        if (!_.isEmpty(contextsToRemove)) {
            _.each(contextsToRemove, function (contextToRemove) {
                registration = {};
                registration.url = currentSubmissionModel.getActionsRegistration(contextToRemove.contextUri);
                registration.contextUri = contextToRemove.contextUri;
                registrationsToRemove.push(registration);
                _.remove($scope.actions, function (contextActions) {
                    return contextActions.contextType === contextToRemove.contextType;
                });
            });
        }

        if (!_.isEmpty(contextsToAdd)) {
            actionIdsToAdd = wizardActionUtil.getActionIds(contextsToAdd);
        }

        submissionMediator.deleteActionRegistrations(registrationsToRemove).finally(function () {
            wizardActionUtil.resetActions();
            wizardActionUtil.getAllActions(actionIdsToAdd).then(function (allActions) {
                $scope.actions = _.concat($scope.actions, allActions);
            });
        });

        $scope.actionsTimeLastModified = new Date().getTime();
    }

    $scope.$on(coreConstant.event.QUOTE_DELETED, function () {
        $scope.viewModel.quoteId = null;
    });

    $scope.$on(submissionConstant.event.REFRESH_SNIPPETS_TOGGLER, function (e, snippetsList) {
        $scope.viewModel.totalSnippetsItems = snippetsList.length;

        if ($scope.viewModel.openDrawers.snippets && $scope.viewModel.totalSnippetsItems <= 0) {
            $rootScope.$broadcast(submissionConstant.event.CLOSE_SNIPPETS);
        }
    });

    $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
        submissionMediator.clearCurrentActionRegistrations().finally(function () {
            loadActions();
        });
    });

    loadActions();
    loadDrawersState();
    refreshSubmission(currentSubmissionModel.getCurrentSubmission());
};

angular.module('gw-um-submission')
    .controller('wizardController', WizardController);
